export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_02_poweredge.1299233e.mp4";